const accountActionTypes = {
  FORGOT_PASSWORD_REQUEST: 'FORGOT_PASSWORD_REQUEST',
  FORGOT_PASSWORD_SUCCESS: 'FORGOT_PASSWORD_SUCCESS',
  FORGOT_PASSWORD_FAILURE: 'FORGOT_PASSWORD_FAILURE',
  REMOVE_FORGOT_PASSWORD_DATA: 'REMOVE_FORGOT_PASSWORD_DATA',

  REMOVE_RESET_PASSWORD_DATA: 'REMOVE_RESET_PASSWORD_DATA',
  RESET_PASSWORD_REQUEST: 'RESET_PASSWORD_REQUEST',
  RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
  RESET_PASSWORD_FAILURE: 'RESET_PASSWORD_FAILURE',
};

export default accountActionTypes;
